import axios from 'axios'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import 'bootstrap'
import Vue from 'vue'
import Datetime from 'vue-datetime'
import vSelect from 'vue-select'
import VueBootstrap, {
    BBreadcrumb,
    BBreadcrumbItem,
    BButton,
    BModal,
} from 'bootstrap-vue'

import Loading from '@/components/Loading.vue'
import * as VueSVGIcon from 'vue-svgicon'
import VueSkipTo from 'vue-skip-to'
import VueGtm from 'vue-gtm'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/components/icons'
import './styles/main.scss'
import 'vue-datetime/dist/vue-datetime.css'

if (process.env.VUE_APP_GTM_ID) {
    Vue.use(VueGtm, {
        id: process.env.VUE_APP_GTM_ID, // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
        enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
        debug: process.env.NODE_ENV !== 'production', // Whether or not display console logs debugs (optional)
        vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    })
}

Vue.use(VueSkipTo)


momentDurationFormatSetup(moment)

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

Vue.config.productionTip = false

Vue.use(VueSVGIcon, {
    classPrefix: 'svg',
    isOriginalDefault: true,
    tagName: 'svg-icon',
})

Vue.use(VueBootstrap)
Vue.use(Datetime)

vSelect.props.components.default = () => ({
    Deselect: {
        render: (createElement) => createElement('span', ''),
    },
});

Vue.component('vue-select', vSelect)
Vue.component('b-breadcrumb', BBreadcrumb)
Vue.component('b-breadcrumb-item', BBreadcrumbItem)
Vue.component('b-button', BButton)
Vue.component('b-modal', BModal)
Vue.component('loading', Loading)

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
